/**
 * Idle-guard tiers (BOU-2974).
 *
 * The guard redirects an idle page to `/` — the user stays signed in, but the page
 * unmounts, which closes every WebSocket, SSE stream and poller it held. That is what
 * lets the Cloud Run backend scale to zero, so every surface needs a finite window;
 * "no timeout" keeps an instance warm for as long as the tab is open.
 *
 * Two tiers, and long-running tools take the second rather than opting out entirely.
 */

/** Ordinary pages: long enough not to interrupt, short enough to release quickly. */
export const DEFAULT_IDLE_TIMEOUT_MS = 10 * 60 * 1000;

/** How long the "still there?" modal counts down before the redirect fires. */
export const DEFAULT_IDLE_WARNING_MS = 2 * 60 * 1000;

/**
 * Long-running tools — image/video generation, journey authoring, scene flight, a
 * live fight. Covers any real working session; still finite, so an abandoned tab
 * eventually lets go.
 */
export const LONG_RUNNING_IDLE_TIMEOUT_MS = 60 * 60 * 1000;
